import { DocumentNode } from 'graphql';
import * as lodash from 'lodash';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../UtilMixin';
import IconText from '../shared/iconText.vue';
import SectionTitle from '../shared/sectionTitle.vue';
import SuggestionEntryMetadata from '../shared/suggestionEntryMetadata.vue';
import SuggestionSource from '../shared/suggestionSource.vue';
import AddItemToSuggestionsListForm from './addItemToSuggestionsListForm.vue';

type mutationFunction = (entry: any) => DocumentNode;

@Component({
  components: {
    IconText,
    SectionTitle,
    SuggestionSource,
    SuggestionEntryMetadata,
    AddItemToSuggestionsListForm,
  },
})
export default class BooksCarousel extends Mixins(UtilMixin) {
  // The title of the carousel
  @Prop() public title!: string;

  // Query and its variables.
  @Prop() public query!: DocumentNode;

  // @Prop() public queryVariables!: (openValue: string, options?: any) => any;
  @Prop() public tenantId!: string;
  @Prop() public suggestionsListId!: string;

  // Mutation and its variables.
  @Prop() public mutation!: DocumentNode | mutationFunction;
  @Prop() public mutationVariables!: (suggestionCandidate: any) => any;

  // The name of the result in the query
  @Prop() public queryResultName!: string;

  @Prop({ default: false }) public openValue!: boolean;

  @Prop({ default: () => [] }) public keywords!: string[];

  public openValueModel = '';

  public selectedFilters = [
    'COLLABORATIVE_FILTERING',
    'MISSING_POPULAR',
    'HIGH_DEMAND',
    'SEARCH',
    'AWARDS',
    'STAFF_PICKS',
  ];

  public filtersCheckboxOptions: any[] = [];

  public added(suggestionCandidate: any): void {
    // const entriesQueryName = (entriesQuery
    // .definitions[0] as OperationDefinitionNode).name!.value;
    // console.log('*** QUERY NAME ' + entriesQueryName);
    const publicationIdentifier =
      suggestionCandidate.publication.metadata.identifier;
    this.$apollo
      .mutate({
        mutation: lodash.isFunction(this.mutation)
          ? this.mutation(suggestionCandidate)
          : this.mutation,
        variables: this.mutationVariables(suggestionCandidate),
        update: (store) => {
          console.log('model (after mutation) ' + this.openValueModel);
          console.log('filters (after filters) ' + this.selectedFilters);
          // Read the data from the original cache,
          const cachedData = store.readQuery({
            query: this.query,
            variables: this.queryVariables,
          }) as any;
          // and remove the entry
          lodash.remove(
            cachedData[this.queryResultName].entries,
            (entry: any) => {
              return (
                entry.publication.metadata.identifier === publicationIdentifier
              );
            }
          );
          // then write it back to the cache
          store.writeQuery({
            query: this.query,
            variables: this.queryVariables,
            data: cachedData,
          });
        },
      })
      .catch((e) => {
        console.log(e);
        console.log('euh');
      });
  }

  public get queryVariables() {
    console.log('reactivity!');
    return {
      query: this.openValueModel,
      tenantId: this.tenantId,
      suggestionsListId: this.suggestionsListId,
      filters: this.selectedFilters,
    };
  }

  public mounted(): void {
    this.filtersCheckboxOptions = [
      {
        text: this.$t('common.adders.user_preferences'),
        value: 'COLLABORATIVE_FILTERING',
      },
      {
        text: this.$t('common.adders.missing_popular'),
        value: 'MISSING_POPULAR',
      },
      {
        text: this.$t('common.adders.high_demand'),
        value: 'HIGH_DEMAND',
      },
      {
        text: this.$t('common.adders.awards'),
        value: 'AWARDS',
      },
      {
        text: this.$t('common.adders.staff_picks'),
        value: 'STAFF_PICKS',
      },
      {
        text: this.$t('common.app.others'),
        value: 'SEARCH',
      },
    ];
  }
}
